<template>
  <LightPlanAccessDeniedModal
    v-if="isSubscriptionGroup(SUBSCRIPTION_GROUP.LIGHT) || isSubscriptionGroup(SUBSCRIPTION_GROUP.HIBERNATION)"
    segment-prompt-type="monthly_session_limit"
    :name="name"
  >
    <template #header>Monthly free sessions limit reached</template>
    <template #description>
      With the Pro plan you can book unlimited calls with mentors. Upgrade your
      plan to book more calls.
    </template>
  </LightPlanAccessDeniedModal>
  <BaseModal v-else :name="name" width-class="tw-max-w-[550px]">
    <div>
      <div
        class="tw-flex tw-justify-center tw-rounded-t-xl tw-bg-error-500 tw-p-3"
      >
        <WarningIcon class="tw-h-6 tw-w-6 tw-text-white" />
      </div>
      <div class="tw-p-5 tw-text-center">
        <h2 class="tw-heading-2">Monthly free sessions limit reached</h2>
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import { SUBSCRIPTION_GROUP } from '@/shared/data/permissionSystem.js'
import WarningIcon from '@/assets/images/icons/warning.svg'
import LightPlanAccessDeniedModal from '@/shared/components/modals/LightPlanAccessDeniedModal.vue'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import BaseModal from '@/shared/components/BaseModal.vue'

defineProps({
  name: {
    type: String,
    required: true,
  },
})

const { isSubscriptionGroup } = usePermissionSystem()
</script>
